import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelTypesDictionaryInfo', request)
}

export {get}
